import { Input, SelectPropsValue } from 'commons/components';

type InputDataPointType = {
    inputName: string;
    inputValue?: string;
    inputPlaceholder?: string;
    showTooltip: boolean;
    onChange: (field: string, value: SelectPropsValue) => void;
};

export const InputDataPoint: React.FC<InputDataPointType> = (props) => {
    const { inputName, inputValue, inputPlaceholder, showTooltip, onChange } = props;

    return (
        <Input
            className="without-label"
            id={`${inputName}-${showTooltip ? 'showTooltip' : ''}`}
            name={inputName}
            placeholder={
                inputPlaceholder ?? 'settings.integrations.active-directory.data-points.mapping.poc.placeholder'
            }
            value={inputValue}
            onChange={onChange}
            disabled
        />
    );
};
